import { FCWithChildren } from '@types';
import React from 'react';

import { NotFound } from '@components';

import Account from '@pages/Account';
import Admin from '@pages/Admin';
import Checkout from '@pages/Checkout';
import CompleteProfile from '@pages/CompleteProfile';
import FAQ from '@pages/FAQ';
import ForgotPassword from '@pages/ForgotPassword';
import Home from '@pages/Home';
import Login from '@pages/Login';
import MacAddressRedirect from '@pages/MacAddressRedirect';
import Main from '@pages/Main';
import ManageDevices from '@pages/ManageDevices';
import ManagedCampus from '@pages/ManagedCampus';
import Notifications from '@pages/Notifications';
import PreAuthentication from '@pages/PreAuthentication';
import Register from '@pages/Register';
import ResetPassword from '@pages/ResetPassword';
import SchoolForm from '@pages/Admin/pages/School';
import Services from '@pages/Services';
import Support from '@pages/Support';
import GuestVisitorsConfirm from '@pages/GuestVisitorsConfirm';
import GuestProcessing from '@pages/GuestProcessing';
import GuestsAndVisitors from '@pages/GuestsAndVisitors';
import DeviceConfirm from '@pages/DeviceConfirm';
import ThankYouGuest from '@pages/ThankYouGuest';
import RetrieveProfile from '@pages/RetrieveProfile';
import CaptivePortalSplash from '@pages/CaptivePortalSplash';
import CaptivePortalContinue from '@pages/CaptivePortalContinue';
import CaptivePortalGuest from '@pages/CaptivePortalGuest';
import CaptivePortalGuestProcessing from '@pages/CaptivePortalGuestProcessing';
import CaptivePortalInstructions from '@pages/CaptivePortalInstructions';

export interface IRoute {
  auth?: boolean;
  component: FCWithChildren<any>;
  exact?: boolean;
  isBoldynRoute?: boolean;
  path: string | string[];
  noHeader?: boolean;
  noFooter?: boolean;
}

const ROUTES: IRoute[] = [
  {
    auth: false,
    component: Main,
    exact: true,
    isBoldynRoute: true,
    path: '/select',
  },
  {
    auth: true,
    component: Account,
    isBoldynRoute: false,
    path: '/account',
  },
  {
    auth: false,
    component: Admin,
    isBoldynRoute: false,
    path: '/admin',
  },
  {
    auth: false,
    component: MacAddressRedirect,
    isBoldynRoute: false,
    exact: true,
    path: [
      `/:mac(\\w{2}:\\w{2}:\\w{2}:\\w{2}:\\w{2}:\\w{2})`,
      '/:mac(\\w{2}%3A\\w{2}%3A\\w{2}%3A\\w{2}%3A\\w{2}%3A\\w{2})',
    ],
  },
  {
    auth: true,
    component: Checkout,
    isBoldynRoute: false,
    path: '/checkout',
  },
  {
    auth: false,
    component: PreAuthentication,
    isBoldynRoute: false,
    exact: true,
    path: '/',
  },
  {
    auth: false,
    component: Login,
    exact: true,
    isBoldynRoute: false,
    path: '/login',
  },
  {
    auth: true,
    component: ManageDevices,
    isBoldynRoute: false,
    path: '/manage-devices',
  },
  {
    auth: true,
    component: Notifications,
    isBoldynRoute: false,
    path: '/notifications',
  },
  {
    auth: false,
    component: Register,
    isBoldynRoute: false,
    path: '/register',
    noFooter: true,
  },
  {
    auth: false,
    component: RetrieveProfile,
    isBoldynRoute: false,
    path: '/retrieve-profile',
    noFooter: true,
  },
  {
    auth: true,
    component: Services,
    isBoldynRoute: false,
    path: '/services',
  },
  {
    auth: false,
    component: Support,
    isBoldynRoute: false,
    path: '/support',
  },
  {
    auth: true,
    component: Home,
    isBoldynRoute: false,
    path: '/home',
  },
  {
    auth: true,
    component: ManagedCampus,
    isBoldynRoute: false,
    path: '/managed-campus',
  },
  {
    auth: false,
    component: CompleteProfile,
    isBoldynRoute: false,
    path: '/complete-profile',
  },
  {
    auth: true,
    component: FAQ,
    isBoldynRoute: false,
    path: '/faq',
  },
  {
    auth: false,
    component: NotFound,
    isBoldynRoute: true,
    path: '/not-found',
  },
  {
    auth: false,
    component: SchoolForm,
    isBoldynRoute: false,
    path: '/admin-schools',
  },
  {
    auth: false,
    component: ResetPassword,
    exact: true,
    isBoldynRoute: false,
    path: '/reset-password',
  },
  {
    auth: false,
    component: ForgotPassword,
    exact: true,
    isBoldynRoute: false,
    path: '/forgot-password',
  },
  {
    auth: false,
    component: GuestVisitorsConfirm,
    isBoldynRoute: false,
    path: '/guest-confirm',
  },
  {
    auth: false,
    component: GuestsAndVisitors,
    isBoldynRoute: false,
    path: '/guest-visitors',
  },
  {
    auth: false,
    component: GuestProcessing,
    isBoldynRoute: false,
    path: '/guest-processing',
  },
  {
    component: DeviceConfirm,
    isBoldynRoute: false,
    path: '/device-confirm',
  },
  {
    component: ThankYouGuest,
    isBoldynRoute: false,
    path: '/thank-message-guest',
  },
  {
    auth: false,
    component: ForgotPassword,
    exact: true,
    isBoldynRoute: false,
    path: '/captive-portal/forgot-password',
    noHeader: true,
    noFooter: true,
  },
  {
    auth: false,
    component: GuestVisitorsConfirm,
    isBoldynRoute: false,
    path: '/captive-portal/guest-confirm',
    noHeader: true,
    noFooter: true,
  },
  {
    auth: false,
    component: CaptivePortalGuest,
    isBoldynRoute: false,
    path: '/captive-portal/guest-visitors',
    noHeader: true,
    noFooter: true,
  },
  {
    auth: false,
    component: CaptivePortalGuestProcessing,
    isBoldynRoute: false,
    path: '/captive-portal/guest-processing',
    noHeader: true,
    noFooter: true,
  },
  {
    auth: false,
    component: Login,
    exact: true,
    isBoldynRoute: false,
    path: '/captive-portal/login',
    noHeader: true,
    noFooter: true,
  },
  {
    auth: false,
    component: Register,
    isBoldynRoute: false,
    path: '/captive-portal/register',
    noHeader: true,
    noFooter: true,
  },
  {
    auth: false,
    component: CompleteProfile,
    isBoldynRoute: false,
    path: '/captive-portal/complete-profile',
    noHeader: true,
    noFooter: true,
  },
  {
    component: CaptivePortalSplash,
    isBoldynRoute: false,
    path: '/captive-portal/splash',
    noHeader: true,
    noFooter: true,
  },
  {
    component: CaptivePortalContinue,
    isBoldynRoute: false,
    path: '/captive-portal/continue',
    noHeader: true,
    noFooter: true,
  },
  {
    component: CaptivePortalInstructions,
    isBoldynRoute: false,
    path: '/captive-portal/instructions',
    noHeader: true,
    noFooter: true,
  },
];

export default ROUTES;
